import { ChangeDetectorRef, Component, OnInit, ViewRef,LOCALE_ID, Output, Input, ViewChild, ElementRef, EventEmitter } from '@angular/core'
import { ErrorStateMatcher, MatDialog } from '@angular/material'
const KEY = 'consultation-index'
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { debounceTime, map, startWith } from 'rxjs/operators'
import { BehaviorSubject, Subject } from 'rxjs'
export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(
        control: FormControl | null,
        form: FormGroupDirective | NgForm | null
    ): boolean {
        const isSubmitted = form && form.submitted
        return !!(
            control &&
            control.invalid &&
            (control.dirty || control.touched || isSubmitted)
        )
    }
}
@Component({
    selector: 'atyl-location-input',
    templateUrl: './location-input.component.html',
    styleUrls: ['./location-input.component.scss'],
    providers: [],
})

@Stringable({
    path: 'views/pages/consultation/index',
    key: KEY,
})
export class LocationInputComponent implements OnInit {

    @Input() locationsList: any[] = [];
    @Input() initLieuSubject: BehaviorSubject<any>;
    @Input() label: any[] = [];
    @Input() errorLabel: string = null;
    @Input() isMulti: boolean;
    @Input() customClass:string = '';
    @Output() locationChange: any = new EventEmitter();

    @ViewChild('locationListInput', { read: undefined, static: undefined }) locationListInput: ElementRef<HTMLInputElement>

    townOptions: any;
    lieux: any[] = [];
    locationFormControl = new FormControl('', [Validators.required]);
    lieuxUpdateSubject: Subject<any> = new Subject<any>();



	constructor(
	  private changeDetectorRef: ChangeDetectorRef,
	) { }

    ngOnInit() {
        this.townOptions = this.locationFormControl.valueChanges.pipe(
            startWith(''),
            debounceTime(200),
            map(value => this.filterLocations(value))
        );
        if(this.initLieuSubject != undefined && this.initLieuSubject){
            this.initLieuSubject.subscribe(lieux=>{
              //  console.log("___lieuxSubject",lieux,this.isMulti);
                if(lieux){
                    if(this.isMulti && lieux && lieux.length>0){
                        this.lieux = lieux;
                    }
                    else if(!this.isMulti){
                        this.locationFormControl.setValue({ID:lieux});
                        //reçu sous la forme d'un id
                        this.lieux = lieux;
						console.log("___this.lieux refrsh",this.lieux,this.isMulti);
					//	this.changeDetectorRef.detectChanges();
                    }
                }
              //  console.log("___this.lieux",this.lieux,this.isMulti);
            })
        }
    }

    updateLieux(location:any,typeModif:string){
        if(this.isMulti){
            if(typeModif == "add"){
                this.addLieu(location);
            }
            else if(typeModif == "remove"){
                this.removeLieu(location);
            }
            this.locationChange.emit(this.lieux);
        }
        else{
            this.lieux = [location.ID];
            console.log("___lieux",this.lieux);
            this.locationChange.emit(this.lieux[0]);
        }
        this.lieuxUpdateSubject.next();
    }
    
    addLieu(location){
        this.lieux.push({"ID": location.ID,"NOM":location.nom});     
        this.locationListInput.nativeElement.value = '';
    }
	
    removeLieu(location){
        this.lieux = this.lieux.filter(lieu => lieu.ID !== location.ID);
    }

    filterLocations(value: any): any[] {
        if (((value!=undefined && value && typeof value=="string") || this.lieux.length>0)) {
            const valueFilter = value!=undefined && value && typeof value=="string"? value: "";
            return this.locationsList
            .map(group => ({ label: group.label, consultations: this.filterLocation(group.consultations, valueFilter) }))
            .filter(group => group.consultations.length > 0);
        }
        return this.locationsList;
    }
    
    private filterLocation(opt: string[], val: string) {
        const filterValue = (val && val != "") ? val.toLowerCase().replace(/\*/g, '') : "";
        return opt.filter(
            item => (item["nom"].toLowerCase().includes(filterValue)
            || item["town"].toLowerCase().includes(filterValue))
            && !this.lieux.find(loc => loc.ID == item["ID"]) 
        );
    }

    displayAutoLocationList(value: any) {
		//console.log("displayAutoLocationList",value)
		let label:any="";
		this.locationsList.forEach((r: any) => {
			let cs:any[]=r.consultations;
			let stop:boolean=false;
			cs.forEach((c: any) => {
				if (!stop 
					&& c.ID==value.ID ){
                        console.log("___stop",c)
                        stop=true;
                        label=c.nom;
						//this.changeDetectorRef.detectChanges();
				}
			});
		})
		return label;
	}

}
